var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-intergation-version__wrapper"},[_c('NewVersionIntegration')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }